import httpService from "./http.service";

class AdvertisementService {
  getAdvertisementUrl = "/advertisement";

  getAdvertisement = () => {
    return httpService.get(this.getAdvertisementUrl);
  };
  createAdvertisement = (model) => {
    return httpService.form("/advertisement", model, "createAdvertisement");
  };
  editAdvertisement = (id, model) => {
    return httpService.form("/advertisement/" + id, model, "editAdvertisement", {}, "patch");
  };
  deleteAdvertisement = (id) => {
    return httpService.delete("/advertisement/" + id);
  };
}

const advertisementService = new AdvertisementService();
export default advertisementService;
